export const DAG_MATURITY_FORM_VALUES = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
} as const;

export type DagMaturityFormValue = (typeof DAG_MATURITY_FORM_VALUES)[keyof typeof DAG_MATURITY_FORM_VALUES];

export const DAG_ENTITY_TYPES = {
  DATASET: 'dataset',
  FEATURE_SET: 'feature_set',
} as const;

export type DagEntityType = (typeof DAG_ENTITY_TYPES)[keyof typeof DAG_ENTITY_TYPES];
